<template lang="pug">
#approvalContainer
  .list
    myApplication(ref="myApplication" v-if="activeName==='1'")
    myCreate(ref="myCreate" v-if="activeName==='2'")
    newApproval(ref="newApproval" v-if="activeName==='3'")
  van-tabbar(v-model="activeName" safe-area-inset-bottom)
    van-tabbar-item(title='我的审批' name="1")
      span 我的审批
      template(#icon="props")
        img(:src="props.active ? tabbarIcons.tab1.active : tabbarIcons.tab1.normal")
    van-tabbar-item( title='我的创建' name="2")
      span 我的创建
      template(#icon="props")
        img(:src="props.active ? tabbarIcons.tab2.active : tabbarIcons.tab2.normal")
    van-tabbar-item(title='发起审批' name="3")
      span 发起审批
      template(#icon="props")
        img(:src="props.active ? tabbarIcons.tab3.active : tabbarIcons.tab3.normal")
</template>

<script>
import newApproval from "./InitiateApproval/index.vue";
import myApplication from "./InitiateApproval/myApproval.vue";
import myCreate from "./InitiateApproval/myCreated.vue";
export default {
  components: { newApproval, myApplication, myCreate },
  data () {
    return {
      activeName: '1',
      tabbarIcons: {
        tab1: {
          active: require('./icon/tab2_active.png'),
          normal: require('./icon/tab2_normal.png')
        },
        tab2: {
          active: require('./icon/tab3_active.png'),
          normal: require('./icon/tab3_normal.png')
        },
        tab3: {
          active: require('./icon/tab1_active.png'),
          normal: require('./icon/tab1_normal.png')

        }
      }
    };
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
#approvalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .list{
    height: calc(100% - 50px);
  }
}
</style>
<style>
#approval-body{
  height:100%;
  width: 100%;
  background:#F5F6FA;
}
</style>
